<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-fleet-form modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>{{ keyData ? 'แก้ไขข้อมูลลูกค้าฟลีต' : 'เพิ่มลูกค้าฟลีต' }}</span>
                        </h4>

                        <button class="btn-close" @click="hide(false)"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="form" v-if="formData && errorData">
                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>ชื่อบริษัท</label>
                                        <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.company.blank }"
                                                maxlength="100"
                                                placeholder="ชื่อบริษัท"
                                                v-model="formData.company" />
                                        <div class="input-error-message" v-if="errorData.company.blank">โปรดกรอกชื่อบริษัท</div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>เลขประจำตัวผู้เสียภาษี</label>
                                        <input type="tel" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.taxId.blank }"
                                                maxlength="20"
                                                placeholder="เลขประจำตัวผู้เสียภาษี"
                                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                                v-model="formData.taxId" />
                                        <div class="input-error-message" v-if="errorData.taxId.blank">โปรดกรอกเลขประจำตัวผู้เสียภาษี</div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="field">
                                        <label>ที่อยู่</label>
                                        <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.address.blank }"
                                                maxlength="500"
                                                placeholder="ที่อยู่"
                                                v-model="formData.address" />
                                        <div class="input-error-message" v-if="errorData.address.blank">โปรดกรอกที่อยู่</div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>ชื่อผู้ติดต่อ</label>
                                        <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.contactPerson.blank }"
                                                maxlength="100"
                                                placeholder="ชื่อผู้ติดต่อ"
                                                v-model="formData.contactPerson" />
                                        <div class="input-error-message" v-if="errorData.contactPerson.blank">โปรดกรอกชื่อผู้ติดต่อ</div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>เบอร์ติดต่อ</label>
                                        <input type="tel" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.contactTel.blank }"
                                                maxlength="20"
                                                placeholder="เบอร์ติดต่อ"
                                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                                v-model="formData.contactTel" />
                                        <div class="input-error-message" v-if="errorData.contactTel.blank">โปรดกรอกเบอร์ติดต่อ</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>วันที่วางบิล (ทุกวันที่ ... เดือนถัดไป)</label>
                                        <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.billDate.blank }"
                                                maxlength="20"
                                                placeholder="5, 25"
                                                v-model="formData.billDate" />
                                        <div class="input-error-message" v-if="errorData.billDate.blank">โปรดกรอกวันที่วางบิล</div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>ระยะเครดิต (วัน)</label>
                                        <input type="tel" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.creditPeriod.blank }"
                                                maxlength="3"
                                                placeholder="ระยะเครดิต"
                                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                                v-model="formData.creditPeriod" />
                                        <div class="input-error-message" v-if="errorData.creditPeriod.blank">โปรดกรอกระยะเครดิต</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>เงื่อนไขการชำระเงิน</label>
                                        <dropdown
                                            v-model="formData.paymentMethod"
                                            placeholder="-- เลือกวิธีชำระเงิน --"
                                            :options="option.paymentMethod"
                                            :classes="{ input: ['input-field', (errorData.paymentMethod.blank ? 'invalid' : '')] }"
                                        ></dropdown>
                                        <div class="input-error-message" v-if="errorData.paymentMethod.blank">โปรดกรอกระยะเครดิต</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="field">
                                        <label class="optional">หมายเหตุ</label>
                                        <input type="text" 
                                                class="input-field"
                                                maxlength="200"
                                                v-model="formData.remark" />
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3 text-right">
                                <button class="btn btn-main" @click="saveCustomerFleet()">บันทึก</button>
                                <button class="btn btn-grey-outline" @click="hide(false)">ปิด</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import OptionPaymentMethod from '@/database/staticOption/PaymentMethod';
import DBFleet from '@/database/Fleet';

export default {
    data() {
        return {
            isActive: false,
            option: { paymentMethod: OptionPaymentMethod.option },
            formData: null,
            errorData: null
        };
    },
    props: {
        isDisplay: Boolean,
        keyData: [Number, String]
    },
    watch: {
        async isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.formData = await this.initFormData();
                this.errorData = this.initValidateData();
            }
        }
    },
    methods: {
        hide(isReload) {
            this.$emit('hide', isReload);
        },
        async initFormData() {
            let data = null;

            if (this.keyData) {
                data = await DBFleet.getDetail(this.keyData);
            }

            return this.mapViewData(data);
        },
        mapViewData(data) {
            return {
                key: data ? data.key : '',
                company: data ? data.company : '',
                taxId: data ? data.taxId : '',
                address: data ? data.address : '',
                contactPerson: data ? data.contactPerson : '',
                contactTel: data ? data.contactTel : '',
                billDate: data ? data.billDate : '',
                creditPeriod: data ? data.creditPeriod : '',
                paymentMethod: data ? data.paymentMethod : '',
                remark: data ? data.remark : ''
            }
        },
        initValidateData() {
            return {
                company: { blank: false },
                taxId: { blank: false },
                address: { blank: false },
                contactPerson: { blank: false },
                contactTel: { blank: false },
                billDate: { blank: false },
                creditPeriod: { blank: false },
                paymentMethod: { blank: false }
            }
        },
        async saveCustomerFleet() {
            if (this.validateData()) {
                const loader = this.$AppUtility.renderLoadBackdrop();
                
                await DBFleet.save(this.formData);

                this.hide(true);
                loader.hide();
            }
        },
        validateData() {
            this.errorData = this.initValidateData();
            let valid = true;

            for (const property in this.errorData) {
                if (!this.formData[property].trim()) {
                    this.errorData[property].blank = true;
                    valid = false;
                }
            }

            return valid;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-fleet-form {
    max-width: 800px;
}
</style>